import React, { Component } from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { Content } from './Content';

export class NewLayout extends Component {
    static displayName = NewLayout.name;

    render() {
        return (

            <div className="container">
                <Header />
                <Content />
                <Footer />
            </div>

        );
    }
}